import { CampaignSectionState } from './OnsiteCampaignSectionState';

// this is populated with some default values -- will be implemented as part of another ticket
export const campaignSectionInitialState: CampaignSectionState = {
  selectedCampaign: {
    id: 'new',
    name: '',
    updatedBy: 'tester name',
  },
};
